import {DeliveryOption} from '@wix/delivery-section-cart/types';
import {DeliverySectionOptionModel} from './DeliverySectionOption.model';

export class DeliverySectionModel {
  public options: DeliverySectionOptionModel[];
  public optionsJson: string;
  public selectedDeliveryOption: DeliverySectionOptionModel;

  constructor(options: DeliveryOption[], selectedCarrierId: string) {
    this.optionsJson = JSON.stringify(options);
    this.options =
      options.filter((option) => !option.hasTimeSlots).map((option) => new DeliverySectionOptionModel(option)) ||
      /* istanbul ignore next */ [];
    this.selectedDeliveryOption = this.options.find((option) => option.id === selectedCarrierId);
  }
}
